import { Component } from '@angular/core';

@Component({
  selector: 'pm-roles-list',
  templateUrl: './roles-list.component.html',
  styleUrls: ['./roles-list.component.sass']
})
export class RolesListComponent {
  public showRoles = true;
  public showAddRol = false;
  public showEditRol = false;
  public editnumber = 0;
  public showEditRolPermissions = false;
}
